<script>
  import { _ } from "svelte-i18n";
  import { useQuery } from "@sveltestack/svelte-query";
  import superagent from "superagent";
  let inProgress = false;

  export let active;
  export let onClose;
  export let documentType = false;
  let openSections = [];

  function close() {
    onClose();
    inProgress = false;
  }
  let document;
  let title = "";
  const documentContent = useQuery(`documents-${documentType}`, () =>
    superagent
      .get("/api/documents/" + documentType + "?lang=" + $_("lang"))
      .then((response) => response.body)
  );

  $: if (!$documentContent.isLoading && $documentContent.data) {
    document = $documentContent.data.content;
    title = $documentContent.data.title;
  }
</script>

{#if active}
  <div class="modal">
    <div class="modal__backdrop" />
    <div class="modal__wrapper">
      <div
        class="modal__content"
        style="animation: 0s ease 0s 1 normal none running none;"
      >
        <div>
          <header class="modal__header">
            {#if !$documentContent.isLoading && $documentContent.data.language !== $_("lang")}
              <p style="color: red;margin-top: -20px">
                {$_("document.noLanguage", {
                  values: {
                    lang: $_("languages." + $documentContent.data.language),
                  },
                })}
              </p>
            {/if}
            <button
              on:click={close}
              type="button"
              class="modal__button-close"
            />
            <h1 class="h2">
              {!!$documentContent.isLoading
                ? $_("document.loadingTitle")
                : title ?? $_("document.noTitle")}
            </h1>
          </header>
          <div class="modal__body">
            <div class="modal__text">
              <section class="card__section">
                <ul class="list-toggle">
                  {#if !!$documentContent.isLoading}
                    <li>{$_("document.loading")}</li>
                  {/if}
                  {#if !$documentContent.isLoading && document}
                    {#each document as section}
                      <li>
                        <button
                          on:click={() =>
                            openSections.includes(section.title)
                              ? (openSections = openSections.filter(
                                  (s) => s !== section.title
                                ))
                              : (openSections = [
                                  ...openSections,
                                  section.title,
                                ])}
                          class="list-toggle__button {openSections.includes(
                            section.title
                          ) && 'is-active'}"
                          ><h4>
                            {document.indexOf(section) + 1}. {section.title}
                          </h4></button
                        >
                        <div
                          class="list-toggle__content {openSections.includes(
                            section.title
                          ) && 'is-toggled'}"
                        >
                          {@html section.content}
                        </div>
                      </li>
                    {/each}
                  {/if}
                  {#if !$documentContent.isLoading && !document}
                    <p>
                      {$_("document.error")}
                      <a
                        href="sms:+4790508006;?&body=Hei! Jeg bruker treningsdagboken og får ikke opp dokument '{title}'."
                        >{$_("document.contact")}
                        <span
                          style="white-space: no-wrap text-decoration:underline;"
                          >905 08 006</span
                        ></a
                      >.
                    </p>
                  {/if}
                </ul>
              </section>
            </div>
            <fieldset class="form-section form-section--submit">
              <div class="layout-buttons layout-buttons--left-right">
                <button on:click={close} type="button" class="button"
                  >{$_("generic.buttons.close")}</button
                >
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
